// 验证手机号码格式
var validatePhone = function(rule, value, callback) {
	const phoneReg = /^[1][3-9]\d{9}$/; // 中国手机号正则表达式
	if (!value || phoneReg.test(value)) {
		callback();
	} else {
		callback(new Error());
	}
}

var rules = {
	order_no: [
		{ required: true, message: "请输入订单号", trigger: "blur" }
	],
	buy_date: [
		{ required: true, message: "请选择购买日期", trigger: "blur" }
	],
	pics: [
		{ required: true, message: "请上传图片", trigger: "blur" }
	],
	phone: [
		{ required: true, message: "请输入手机号码", trigger: "blur"},
		{ validator: validatePhone, message: '请输入有效的手机号码', trigger: 'blur' }
	],
}

export { rules }